module.exports = __webpack_public_path__ + "img/IMG_9519_FoamcoreMatted.3550f2cb.jpg";